import LectureLessonListListResultModelBase from '../_generated/modelBases/lecture-lesson-list-list-result-model-base';

export default class LectureLessonListListResultModel extends LectureLessonListListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
